module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_gaku-4cfd52a12143ee102def4acd391d2872.png";